// extracted by mini-css-extract-plugin
export default {"appearAnimationCell":"appearAnimationCell-COIkv","appearanceCell":"appearanceCell-udKG0","removeAnimationCell":"removeAnimationCell-CIroP","removeCell":"removeCell-kjs1t"};